import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function NewsletterCTA() {
  const { ref, isVisible } = useScrollAnimation();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      await fetch('https://readdy.ai/api/form/d647t3b0723ekv2itmrg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      setIsSuccess(true);
      setEmail('');
    } catch (error) {
      console.error('Submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-[#00989e] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#00b4a6] rounded-full blur-3xl"></div>
      </div>

      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="w-16 h-16 flex items-center justify-center bg-[#00989e]/20 rounded-2xl mx-auto mb-6">
          <i className="ri-mail-send-line text-3xl text-[#00b4a6]"></i>
        </div>

        <h2 className="font-['Montserrat'] text-3xl md:text-4xl font-bold text-white mb-4">
          Get Marketing Tips Delivered Weekly
        </h2>

        <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto">
          Join 5,000+ marketers who receive our latest insights, strategies, and industry updates every Thursday.
        </p>

        {isSuccess ? (
          <div className="bg-[#00989e]/20 border border-[#00989e]/30 rounded-2xl p-6 max-w-md mx-auto">
            <i className="ri-check-line text-4xl text-[#00b4a6] mb-3"></i>
            <p className="text-white font-semibold">You&apos;re subscribed!</p>
            <p className="text-slate-300 text-sm mt-1">Check your inbox for a welcome email.</p>
          </div>
        ) : (
          <form
            id="blog-newsletter-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-6 py-4 rounded-full bg-white/10 border border-white/20 text-white placeholder-slate-400 focus:outline-none focus:border-[#00989e] transition-colors text-sm"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-4 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}

        <p className="text-slate-500 text-xs mt-4">
          No spam, ever. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
}
